"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.status4 = exports.status3 = exports.status2 = exports.status1 = exports.purple = exports.malibu = exports.jet = exports.indigo = exports.disabled = exports.blue = exports.base = void 0;
var base = ['#6AA6EB', '#8C5ED5', '#A32DC1', '#00A1A5', '#0660C8', '#99E9EB', '#5B19C4', '#240A4E', '#005052', '#ECD5F2'];
exports.base = base;
var blue = ['#e6f0fb', '#cde1f8', '#9bc4f2', '#6aa6eb', '#3889e5', '#076cdf', '#0660c8', '#0556b2', '#044085', '#022b59'];
exports.blue = blue;
var purple = ['#EEE8F9', '#CEBAED', '#AD8CE1', '#8C5ED5', '#7B47CF', '#5B19C4', '#48149C', '#360F75', '#240A4E', '#120527'];
exports.purple = purple;
var jet = ['#eaeaeb', '#d6d6d8', '#c2c2c5', '#adadb2', '#98989e', '#84848b', '#707078', '#5b5b66', '#474751', '#33333f'];
exports.jet = jet;
var indigo = ['#ddd9f6', '#ccc7f2', '#bbb4ee', '#9a8ee6', '#7869de', '#5744d6', '#4e3dc0', '#4536ab', '#342880', '#221b55'];
exports.indigo = indigo;
var malibu = ['#E1F1FD', '#C4E4FB', '#A6D7F9', '#89CAF7', '#6CBDF6', '#5697C4', '#407193', '#365E7B', '#2B4B62', '#203849'];
exports.malibu = malibu;
var status1 = ['#7869de', '#ff9b3f', '#dc2f23'];
exports.status1 = status1;
var status2 = ['#3ed483', '#ff9b3f', '#dc2f23'];
exports.status2 = status2;
var status3 = ['#3ed483', '#9feac1', '#dc2f23'];
exports.status3 = status3;
var status4 = ['#3ed483', '#9ee9c1', '#DC2F23'];
exports.status4 = status4;
var disabled = '#D6D6DD';
exports.disabled = disabled;